import React from "react";
import { Link } from "gatsby";
import LinkButton from "components/link_button";
import Style from "styles/components/job_list.module.scss";
const JobList = ({ children }) => {
  return (
    <section className={Style.recruitJob}>
      <div className={Style.recruitJob__inner}>
        <h2 className={Style.recruitJob__head}>JOB LIST</h2>
        <ul className={Style.jobList}>
          <li className={Style.jobListItem}>
            <Link className={Style.jobListItem__link} to="/recruit/backendengineer/">
              <div className={Style.jobListItem__bg}>
                <div className={Style.jobListItem__bgInner}>
                  <div className={Style.jobListItem__txtWrapper}>
                    <div className={Style.jobListItem__txtArea}>
                      <p className={Style.jobListItem__head}>BACKEND ENGINEER</p>
                      <p className={Style.jobListItem__ja}>バックエンドエンジニア</p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
            <div className={Style.jobListItem__desc}>
              <p className={Style.jobListItem__descLabel}>業務内容</p>
              <p className={Style.jobListItem__descText}>ECサイト、コンシューマー向けサービス、大規模ポータルサイトの開発・改修・運用 など</p>
              <p className={Style.jobListItem__descLabel}>言語・歓迎スキル</p>
              <div className={Style.jobListItem__skills}>
                <span className={Style.jobListItem__skill}>Java</span>
                <span className={Style.jobListItem__skill}>PHP</span>
                <span className={Style.jobListItem__skill}>C#</span>
                <span className={Style.jobListItem__skill}>AWS</span>
                <span className={Style.jobListItem__skill}>Azure</span>
                <span className={Style.jobListItem__skill}>GCP</span>
                <span className={Style.jobListItem__skillEtc}>...etc</span>
              </div>
            </div>
          </li>

          <li className={Style.jobListItem}>
            <Link className={Style.jobListItem__link} to="/recruit/frontendengineer/">
              <div className={Style.jobListItem__bg}>
                <div className={Style.jobListItem__bgInner}>
                  <div className={Style.jobListItem__txtWrapper}>
                    <div className={Style.jobListItem__txtArea}>
                      <p className={Style.jobListItem__head}>FRONTEND ENGINEER</p>
                      <p className={Style.jobListItem__ja}>フロントエンドエンジニア</p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
            <div className={Style.jobListItem__desc}>
              <p className={Style.jobListItem__descLabel}>業務内容</p>
              <p className={Style.jobListItem__descText}>新規・既存サービスの開発・改修・運用 など</p>
              <p className={Style.jobListItem__descLabel}>言語・歓迎スキル</p>
              <div className={Style.jobListItem__skills}>
                <span className={Style.jobListItem__skill}>React</span>
                <span className={Style.jobListItem__skill}>Vue.js</span>
                <span className={Style.jobListItem__skill}>TypeScript</span>
                <span className={Style.jobListItem__skill}>WEBデザイン</span>
                <span className={Style.jobListItem__skill}>UIデザイン</span>
                <span className={Style.jobListItem__skillEtc}>...etc</span>
              </div>
            </div>
          </li>

          <li className={Style.jobListItem}>
            <Link className={Style.jobListItem__link} to="/recruit/projectmanager/">
              <div className={Style.jobListItem__bg}>
                <div className={Style.jobListItem__bgInner}>
                  <div className={Style.jobListItem__txtWrapper}>
                    <div className={Style.jobListItem__txtArea}>
                      <p className={Style.jobListItem__head}>PROJECT MANAGER</p>
                      <p className={Style.jobListItem__ja}>プロジェクトマネージャー</p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
            <div className={Style.jobListItem__desc}>
              <p className={Style.jobListItem__descLabel}>業務内容</p>
              <p className={Style.jobListItem__descText}>新規・既存サービスのプロジェクト管理全般 など</p>
              <p className={Style.jobListItem__descLabel}>言語・歓迎スキル</p>
              <div className={Style.jobListItem__skills}>
                <span className={Style.jobListItem__skill}>Java</span>
                <span className={Style.jobListItem__skill}>PHP</span>
                <span className={Style.jobListItem__skill}>C#</span>
                <span className={Style.jobListItem__skill}>BtoC開発</span>
                <span className={Style.jobListItem__skill}>マネジメント</span>
                <span className={Style.jobListItem__skillEtc}>...etc</span>
              </div>
            </div>
          </li>
        </ul>
        {children}
        <p className={Style.recruitJob__extraInfo}>
          掲載求人以外の職種のご相談も大歓迎！お気軽にお問合せ・エントリーお待ちしております。
        </p>
        <LinkButton color={"black"} url={"/contact/"} text={"CONTACT US"} />
      </div>
    </section>
  );
};

export default JobList;
